import React from 'react';
export const TestimonialsPage = () => {
  const testimonials = [{
    name: 'Devora Fuente',
    location: 'Atlanta, GA',
    content: 'I booked with them in April and chose the Tiny Tot Package, He was turning 1 and my little one loved it! I definitely recommend them they are flexible and I love how easy they make it! 😊\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjWcCdZfy9uykczlg7BZusnK_73YTWN8nZIgsjpC4ZlGPDoEeRd2=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Sandy Parker',
    location: 'Newnan, GA',
    content: "What a great experience! We rented the Megatot set up for my granddaughter's 2nd birthday party with kids ranging from 1-4 with 14 children. Everyone had a great time…not a single meltdown! All played happily! The kind people at Toddler Time were great to deal with! Great communication regarding set up and breakdown. Can't recommend them highly enough!! Great value!!!",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocKh8WnTjumiTp8Jxs3sW6WCCbHaMufugXN5g4p4tVF5R3HBcg=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Savannah Easton',
    location: 'Roopville, GA',
    content: "The perfect addition to our daughter's birthday! The family was super sweet and arrived early for setup. The kids had a blast and we will be renting from them again!\n\n\n\n\n",
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjXN6CGzwfI_sCRAGJpmnJ5Xc5WoxPyLxjBYUeMAjRFFrF1a_ubk9Q=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Cassidi Mapp',
    location: 'Conyers, GA',
    content: "I had a great experience booking with Toddler Time for my daughter's 1st birthday party. Their communication was top tier & they were on time for arrival and departure. Although my daughter is pretty young and did not enjoy it as much, there were plenty of other children at the party that had a ball! It definitely keeps them occupied. I 100% recommend booking with Toddler Time!",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocKJ4m68dmrDLzSHPlYJCTjmQnHlaqbpq82Z66uM7ky7_s5AFw=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Laura Avellanda',
    location: 'Ellenwood, GA',
    content: "I love it! I got the mega tot package for my baby's first year birthday and it was a hit! All of the kids really enjoyed it. You should book with them because : - everything was so clean and well maintained. - they arrived on time to do the set up before the party started . - Christine and her husband were so nice , great customer service. - they have the best price for the package compare with other vendors. I will book with them again !❤️",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocI_1vQinX3YngD2UMBYlqZqsw6vvhQx6HXvxauiiAYO3M7LpQ=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Lyric Thomason',
    location: 'Dallas, GA',
    content: "Toddler time came and set up the mega tot package at my son's first birthday party. It was a blast. They were so friendly, quick, and easy. Thank you for making my son's first birthday something we will never forget! 100% recommend for any toddler parties or event 🎉\n\n",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocK_ELAxUSJ8BaCCTqJg0azRfpeR5DuJNmJ4UwEocHztLXinDQ=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Jasmin Moon',
    location: 'Atlanta, GA',
    content: 'Professional and awesome! Definitely would recommend and/or book with again!\n\n\n\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocIipLRzJDTV302-J0Tcf9cOs6VEXFdWh951WTKjWR_YhBJ3fw=w144-h144-p-rp-mo-ba2-br100'
  }, {
    name: 'Rekya Sanders',
    location: 'Marietta, GA',
    content: 'Very nice and professional! Loved the services and will use again! Thank you for making my daughter birthday special!\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocI8Hl5w-VSWkq3OMFBp2ppQqopeSaCvMWUlbFiWDol7kGghwQ=w144-h144-p-rp-mo-ba2-br100'
  }, {
    name: 'Regina Martin',
    location: 'Atlanta, GA',
    content: 'They were excellent at responding in a timely manner! They worked with my schedule and made my day successful\n\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocJGm9Omt59Wx4WrfLsn1uihfCJp-VOF9NuOZYy9JkM_3qIXy7CY=w144-h144-p-rp-mo-br100'
  }];
  return <div className="bg-white w-full" data-id="element-983">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-984">
        <div className="text-center mb-12" data-id="element-985">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-986">
            What Our Customers Say
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-987">
            Read testimonials from families who have experienced the magic of
            Toddler Time
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12" data-id="element-988">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-3xl shadow-md overflow-hidden p-8 relative flex flex-col h-[600px]" data-id="element-989">
              {/* Large quote marks in top right */}
              <div className="absolute top-4 right-4 text-8xl text-gray-100 opacity-50 leading-none" data-id="element-990">
                ❞
              </div>
              {/* Profile section with image and details */}
              <div className="flex items-start mb-6 relative z-10" data-id="element-991">
                <img src={testimonial.image} alt={testimonial.name} className="w-20 h-20 rounded-full mr-4 object-cover" data-id="element-992" />
                <div data-id="element-993">
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-994">
                    {testimonial.name}
                  </h3>
                  <p className="text-gray-500 text-lg" data-id="element-995">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              {/* Stars */}
              <div className="flex mb-6" data-id="element-996">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-6 h-6 text-yellow-300 fill-current mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-id="element-997">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-998" />
                  </svg>)}
              </div>
              {/* Testimonial content */}
              <p className="text-gray-600 italic text-lg leading-relaxed flex-grow whitespace-pre-line" data-id="element-999">
                {testimonial.content}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
};